export { default as EmailIcon } from './email.svg';
export { default as MaximizeIcon } from './maximize.svg';
export { default as MutedIcon } from './muted.svg';
export { default as VolumeIcon } from './volume.svg';
